import {useCustomerSubscriptions} from '../hooks/useCustomerSubscriptions.ts';
import {CustomerSubscription} from '../types';
import {FieldProps} from 'formik';
import {FormikGenericCombobox} from "@flexinet/ui-components";
import {TextInputProps} from "@mantine/core";

export const SubscriptionsAutocomplete = (props: FieldProps & TextInputProps) => {

    // The query fetches on mount by itself. This used to also call fetchRecords() from a
    // useEffect keyed on it, and fetchRecords is a new function every render, so every
    // render invalidated the list and refetched it.
    const {
        items: records,
        loading,
    } = useCustomerSubscriptions();


    return (

        <FormikGenericCombobox
            records={(records as CustomerSubscription[]) || []}
            valueFieldName={'id'}
            renderOption={(record: CustomerSubscription) => `${record.id}`}
            getSelectedOption={(record: CustomerSubscription) => `${record.id}`}
            isLoading={loading}
            {...props}
        />

    );
};